import React, { useState } from "react";
import CitizenAttributesDashboard from "./citizenLevelAttributes/CitizenAttributesDashboard";
import CaseAttributesDashboard from "./caseLevelAttributes/CaseAttributesDashboard";
import CombinedDashboard from "./combined/CombinedDashboard";

const AttributesDashboard = () => {

  const [activeTab, setActiveTab] = useState("combined");

  return (
    <div className='border-2 border-gray-300 shadow-lg shadow-black rounded-md max-w-[90vw] ml-[4vw] p-3'>

      <div className="flex gap-4 mb-6">

       
        {/* ✅ NEW TAB */}
        <button
          className={`px-4 py-2 rounded-lg font-medium 
          ${activeTab === "combined"
            ? "bg-pink-200 text-pink-800 shadow"
            : "bg-gray-200"}`}
          onClick={() => setActiveTab("combined")}
        >
         Citizen Attributes
        </button>

      </div>

      <div>
        {activeTab === "combined" && <CombinedDashboard />}
      </div>

    </div>
  );
};

export default AttributesDashboard;

//  <button
//           className={`px-4 py-2 rounded-lg font-medium 
//           ${activeTab === "citizen"
//             ? "bg-pink-200 text-pink-800 shadow"
//             : "bg-gray-200"}`}
//           onClick={() => setActiveTab("citizen")}
//         >
//           Citizen Level Attributes
//         </button>

//         <button
//           className={`px-4 py-2 rounded-lg font-medium 
//           ${activeTab === "case"
//             ? "bg-pink-200 text-pink-800 shadow"
//             : "bg-gray-200"}`}
//           onClick={() => setActiveTab("case")}
//         >
//           Case Level Attributes
//         </button>

  // {activeTab === "citizen" && <CitizenAttributesDashboard />}
  //      {activeTab === "case" && <CaseAttributesDashboard />}